import React, { Component } from 'react';
import {
  Row,
  Col,
  Container,
} from 'reactstrap';

import 'bootstrap/dist/css/bootstrap.css';
import "react-table/react-table.css";
import "./AdvancedSearch.css";
import AdvancedSearchResults from '../../components/DataResults/AdvancedSearchResults';
import CollapseCard from '../../components/CollapseCard/CollapseCard';
import PermissionWrapper from '../../auth/PermissionWrapper';
import SearchCheckboxes from '../../components/SearchForm/SearchCheckboxes';
import SearchForm from '../../components/SearchForm/SearchForm';
import SearchNotes from '../../components/SearchForm/SearchNotes';
import SearchStatistics from '../../components/SearchForm/SearchStatistics';
import SaveSearchModal from '../../components/SaveSearchModal/SaveSearchModal';
import SearchFooter from '../../components/SearchForm/SearchFooter';
import CompanyContext from '../../auth/CompanyContext';
// import { Prompt } from 'react-router-dom';

class AdvancedSearch extends Component {
  static contextType = CompanyContext;

  constructor(props) {
    super(props);

    this.available_dates = [...props.available_dates].filter(item => item.date_key !== '000000');
    this.pageSizeOptions = [20, 50, 100, 500, 1000, 2500];

    this.search_option_groups = [
      {
        label: 'Total Accounts',
        keyBase: 'total_accounts',
        type: 'number'
      },
      {
        label: 'Total AUM',
        keyBase: 'aum_total',
        type: 'currency'
      },
      {
        label: 'Individual, HNW or Pension Accounts',
        keyBase: 'individual_hnw_pension_accounts',
        type: 'number'
      },
      {
        label: 'Individual, HNW or Pension AUM',
        keyBase: 'individual_hnw_pension_aum',
        type: 'currency'
      },
      {
        label: 'Discretionary or Non-Discretionary Accounts',
        keyBase: 'discretionary_nondiscretionary_accounts',
        type: 'number'
      },
      {
        label: 'Discretionary or Non-Discretionary AUM',
        keyBase: 'discretionary_nondiscretionary_aum',
        type: 'currency'
      },
      {
        keyBase: 'individual_accounts',
        label: 'Individual Accounts',
        type: 'number'
      },
      {
        keyBase: 'individual_aum',
        label: 'Individual AUM',
        type: 'currency'
      },
      {
        keyBase: 'hnw_accounts',
        label: 'HNW Accounts',
        type: 'number'
      },
      {
        keyBase: 'hnw_aum',
        label: 'HNW AUM',
        type: 'currency'
      },
      {
        keyBase: 'pension_accounts',
        label: 'Pension Accounts',
        type: 'number'
      },
      {
        keyBase: 'pension_aum',
        label: 'Pension AUM',
        type: 'currency'
      },
      {
        label: 'Discretionary Accounts',
        keyBase: 'discretionary_accounts',
        type: 'number'
      },
      {
        label: 'Discretionary AUM',
        keyBase: 'discretionary_aum',
        type: 'currency'
      },
      {
        label: 'Non-Discretionary Accounts',
        keyBase: 'nondiscretionary_accounts',
        type: 'number'
      },
      {
        label: 'Non-Discretionary AUM',
        keyBase: 'nondiscretionary_aum',
        type: 'currency'
      }

    ];

    this.primary_search_options = { 'name': "", 'city': "", 'state': "", 'zip': "", 'website': "", 'sec_number': "", 'comments': "" };


    let stateObj = {
      search_params: {},
      show_results: sessionStorage.getItem('advancedSearchShowResults') ? sessionStorage.getItem('advancedSearchShowResults') === 'true' : false,
      current_state: 0,
      no_comparison_values: {},
      showAll: false,
      notesCategories: [],
      reportState: {
        isGlobal: false,
        isLatest: false,
        reportID: 0
      },
      currentDate: this.props.available_dates[this.props.available_dates.length - 1],
      previousDate: this.props.available_dates[this.props.available_dates.length - 2],
      group_selections: {},
      selected: [],
      unsavedChanges: false
    };

    var temp_selections = {}



    this.search_option_groups.forEach((e) => {
      const boolean_key_suffixes = [
        '_cur',
        '_prev',
        '_growth',
        '_growth_percent',
        '_value'
      ];
      const text_key_suffixes = [
        '_growth_min',
        '_growth_max',
        '_growth_percent_min',
        '_growth_percent_max',
        '_value_min',
        '_value_max'
      ];
      text_key_suffixes.forEach((suffix) => {
        temp_selections[e.keyBase + suffix] = '';

        //this.state.no_comparison_values[e.keyBase + suffix] = ''; // was giving compile warnings
        stateObj.no_comparison_values = { [e.keyBase + suffix]: '' }

      });
      boolean_key_suffixes.forEach((suffix) => {
        temp_selections[e.keyBase + suffix] = false;

        if (suffix !== '') {
          //this.state.no_comparison_values[e.keyBase + suffix] = false; // was giving compile warnings
          stateObj.no_comparison_values = { [e.keyBase + suffix]: false }
        }

      });
    });

    temp_selections['new'] = false;
    temp_selections['is_new'] = false;
    temp_selections['hasCommentTypes'] = false;
    temp_selections['hasCommentTypesArray'] = false;
    temp_selections['hasNoNotes'] = false;
    temp_selections['hasNotes'] = false;
    temp_selections['hasNotes_max'] = false;
    temp_selections['hasNotes_min'] = false;
    temp_selections['hasFavorites'] = false;
    temp_selections['hasNoFavorites'] = false;
    temp_selections['showVerbose'] = false;
    temp_selections['showContacts'] = false;
    stateObj.no_comparison_values['is_new'] = false;


    stateObj.group_selections = { ...temp_selections, ...this.primary_search_options };

    if (this.props.location != null && this.props.location.state != null && this.props.location.state.search_params != null) {
      stateObj.search_params = this.props.location.state.search_params;
      stateObj.group_selections = this.props.location.state.search_params;
      stateObj.current_date = this.props.location.state.current_date;
      stateObj.show_results = true;
      sessionStorage.setItem('advancedSearchShowResults', true);
    }

    if (sessionStorage.getItem('advancedSearchGroupSelections')) {
      stateObj.group_selections = JSON.parse(sessionStorage.getItem('advancedSearchGroupSelections'));
    }

    stateObj.current_date = ((stateObj.current_date) === undefined || stateObj.current_date === '') ? this.available_dates.length - 1 : this.available_dates.findIndex(date => date.date_key === stateObj.current_date);
    stateObj.previous_date = stateObj.current_date - 1;

    stateObj.search_params.current_date = this.available_dates[stateObj.current_date]?.date_key || '';
    stateObj.search_params.previous_date = this.available_dates[stateObj.previous_date]?.date_key || '';

    this.showModal = React.createRef();

    if ("state" in this.props.location && this.props.location.state != null && "searchState" in this.props.location.state && this.props.location.state.searchState != null) {
      stateObj = (this.props.location.state.searchState);
    }
    if ("state" in this.props.location && this.props.location.state != null && "reportState" in this.props.location.state && this.props.location.state.reportState != null) {
      stateObj.reportState = this.props.location.state.reportState;
    }
    this.temp_selections = temp_selections;
    this.state = stateObj;
  }

  componentDidMount = () => {
    // console.log('AdvancedSearch.js/getUsers()');
    fetch('/api/notesCategories/', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.props.clientToken,
        'X-Database': this.context.company
      }
    })
      .then(results => results.json())
      .then(results => {
        this.setState((prevState, props) => {
          return {
            notesCategories: results.data
          };
        });
      });
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  handleReset = () => {
    sessionStorage.removeItem('advancedSearchResultsFiltered');
    sessionStorage.removeItem('advancedSearchResultsSorted');
    sessionStorage.removeItem('advancedSearchResultsItems');
    sessionStorage.removeItem('advancedSearchShowResults');
    sessionStorage.removeItem('advancedSearchGroupSelections');
    this.setState({
      group_selections: { ...this.temp_selections, ...this.primary_search_options },
      search_params: null,
      show_results: false,
      current_state: 0,
      unsavedChanges: false
    })
  }

  handleSubmit = () => {

    this.setState((prevState) => {

      let search_params = {};


      for (const [key, value] of Object.entries(prevState.group_selections)) {
        if (prevState.previous_date === null && prevState.no_comparison_values.hasOwnProperty(key)) {
          search_params[key] = prevState.no_comparison_values[key];
        }
        else {
          search_params[key] = value;
        }
      }

      search_params['current_date'] = this.available_dates[prevState.current_date]?.date_key || '';
      search_params['previous_date'] = prevState.previous_date !== null ? this.available_dates[prevState.previous_date]?.date_key || '' : null;

      sessionStorage.removeItem('advancedSearchResultsItems');
      sessionStorage.setItem('advancedSearchShowResults', true);
      sessionStorage.setItem('advancedSearchGroupSelections', JSON.stringify(this.state.group_selections));
      return {
        search_params: search_params,
        show_results: true
      };
    });
  }

  onDismissResults = () => {
    sessionStorage.removeItem('advancedSearchShowResults');
    this.setState({
      search_params: null,
      show_results: false,
      unsavedChanges: false
    });
  }

  onLaunchSaveSearch = (isNew) => {
    this.showModal.current.modalOpen(true, isNew);
  }

  handleTextInputChange = (e, setBool = true) => {
    e.persist();
    this.setState(prevState => {
      const sel = prevState.group_selections;
      sel[e.target.name] = e.target.value;
      if (setBool) sel[(String(e.target.name).substr(0, String(e.target.name).length - 4))] = true;
      if (setBool && String(e.target.name).substr(-10, 7) === '_value_') sel[(String(e.target.name).substr(0, String(e.target.name).length - 10)) + '_cur'] = true;
      return { group_selections: sel }
    }, () => {
      // sessionStorage.setItem('advancedSearchGroupSelections', JSON.stringify(this.state.group_selections));
    });
  }

  handleCategoryInputChange = (e) => {
    e.persist();
    this.setState(prevState => {
      const sel = prevState.group_selections;
      sel[e.target.name] = e.target.value;
      if (e.target.name === 'notes_category') delete sel['notes_category_list'];
      return { group_selections: sel }
    }, () => {
      // sessionStorage.setItem('advancedSearchGroupSelections', JSON.stringify(this.state.group_selections));
    });
  }

  handleBooleanInputChange = (e, setFalse = []) => {
    e.persist();
    //const nameArr = String(e.target.name).split('_');
    //const targetName = nameArr.filter(function(value, index, arr) { return !(value === 'cur' || value === 'prev' || value === 'growth' || value === 'percent')}).join('_');
    this.setState(prevState => {

      const sel = prevState.group_selections;
      sel[e.target.name] = e.target.checked;
      const noteTypes = (e.target.name.indexOf('|') > -1) ? e.target.name.split('|').slice(1) : [];
      sel['hasCommentTypes'] = (noteTypes.length > 0);
      sel['hasCommentTypesArray'] = noteTypes;
      if (!e.target.checked) {
        sel[e.target.name + '_min'] = '';
        sel[e.target.name + '_max'] = '';
      }
      setFalse.forEach(item => {
        sel[item] = false;
      });
      return { group_selections: sel }
    }, () => {
      // sessionStorage.setItem('advancedSearchGroupSelections', JSON.stringify(this.state.group_selections));
    });

  }

  handleToggleCurrent = (e) => {

    e.persist();

    const sel = this.state.group_selections;

    this.setState(prevState => {
      Object.keys(sel).map(function (key) {
        if (key.indexOf('_cur') > -1) {
          sel[key] = e.target.checked;
        }
        return false;
      })
      return {}
    }, () => {
      // sessionStorage.setItem('advancedSearchGroupSelections', JSON.stringify(this.state.group_selections));
    });
  }

  handleTogglePrevious = (e) => {
    e.persist();

    const sel = this.state.group_selections;

    this.setState(prevState => {
      Object.keys(sel).map(function (key) {
        if (key.indexOf('_prev') > -1) {
          sel[key] = e.target.checked;
        }
        return false;
      })
      return {}
    }, () => {
      // sessionStorage.setItem('advancedSearchGroupSelections', JSON.stringify(this.state.group_selections));
    });
  }

  handleDatePickerChange = (e) => {
    //e.persist();
    this.setState(prevState => {
      const sel = prevState.group_selections;
      // console.log(e.target.name + ' ' + e.target.value)
      sel[e.target.name] = e.target.value;

      return {
        group_selections: sel
      }
    }, () => {
      // sessionStorage.setItem('advancedSearchGroupSelections', JSON.stringify(this.state.group_selections));
    });
  }

  handleDateInputChange = (e) => {
    e.persist();

    if (e.target.name === 'current_date') {
      this.setState(prevState => {
        var new_current = this.available_dates.findIndex(d => e.target.value === d.date_string);
        new_current = Math.min(Math.max(new_current, 0), this.available_dates.length - 1);

        var new_state = {
          current_date: new_current
        }

        if (prevState.previous_date >= new_current) {
          new_state.previous_date = new_current > 0 ? new_current - 1 : null;
        }

        return new_state;

      });
    }

    if (e.target.name === 'previous_date') {
      this.setState(prevState => {

        var new_prev = null;

        if (e.target.selectedIndex !== 0) {
          new_prev = this.available_dates.findIndex(d => e.target.value === d.date_string);
          new_prev = Math.min(Math.max(new_prev, 0), this.available_dates.length - 2);
        }

        var new_state = {
          previous_date: new_prev
        }

        if (prevState.current_date <= new_prev) {
          new_state.current_date = new_prev + 1;
        }

        return new_state;

      }, () => {
        // sessionStorage.setItem('advancedSearchGroupSelections', JSON.stringify(this.state.group_selections));
      });
    }
  }

  handleStateInputChange = (e) => {
    e.persist();
    this.setState(prevState => {
      const sel = prevState.group_selections;
      var new_current = this.props.us_states.findIndex(d => e.target.value === d.abbr);
      new_current = Math.min(Math.max(new_current, 0), this.props.us_states.length - 1);
      sel[e.target.name] = e.target.value;

      var new_state = {
        current_state: new_current,
        group_selections: sel
      }

      return new_state;

    }, () => {
      // sessionStorage.setItem('advancedSearchGroupSelections', JSON.stringify(this.state.group_selections));
    });

  }

  handleKeyUp = (e) => {
    e.persist();
    if (e.key === 'Enter') this.handleSubmit();
  }

  changeSelected = (secID) => {
    this.setState(prevState => {
      let obj = { ...prevState }
      obj.unsavedChanges = true;
      if (secID == null) {
        obj.selected = [];
      } else {
        let index = obj.selected.findIndex(i => i === secID);
        if (index === -1) {
          obj.selected.push(secID);
        } else {
          obj.selected.splice(index, 1);
        }
      }
      return obj;
    })
  }

  changeSelectedAllNone = (e, items) => {
    if (e.target.checked) {
      this.setState({
        selected: [...items].map(item => item['SEC#']),
        unsavedChanges: true
      })
    } else {
      this.setState({
        selected: [],
        unsavedChanges: false
      })
    }
  }

  render() {
    const useSECData = this.props.database === 'SecReporting';
    if (this.state != null && "show_results" in this.state && this.state.show_results === true) {
      return (<>
        {/* <Prompt
          when={this.state.unsavedChanges}
          message="You have unsaved changes, are you sure you want to leave?"
        /> */}
        <SaveSearchModal ref={this.showModal}
          clientToken={this.props.clientToken}
          available_dates={this.available_dates}
          group_selections={this.state.group_selections}
          current_date={this.state.current_date}
          previous_date={this.state.previous_date}
          reportState={this.state.reportState}
          type='search'
          user={this.props.user} />

        <AdvancedSearchResults
          searchOptions={this.state.search_params}
          handleReset={this.handleReset}
          onDismissResults={this.onDismissResults}
          onLaunchSaveSearch={this.onLaunchSaveSearch}
          searchState={this.state}
          pageSizeOptions={this.pageSizeOptions}
          showAll={this.state.showAll}
          changeSelected={this.changeSelected}
          changeSelectedAllNone={this.changeSelectedAllNone}
          selected={this.state.selected}
          notesCategories={this.state.notesCategories}
          {...this.props}
        /></>
      );
    }
    else {
      return (
        <div id="_searchContainer">
          {/* <Prompt
            when={this.state.unsavedChanges}
            message="You have unsaved changes, are you sure you want to leave?"
          /> */}
          <Container fluid className='p-0' id="_searchForm">
            <PermissionWrapper {...this.props} allowedPermission="Show Secondary Ribbon" hidden={true}>
              <Row>
                <Col md={12} className='text-center'>
                  <h1>Search</h1>
                </Col>
              </Row>
            </PermissionWrapper>
            <Container fluid>
              {/* <Row className='mx-0'>
              <Col> */}
              <CollapseCard title="Search Criteria" open={true}
              // cb={(isOpen) => localStorage.setItem('searchNotesIsOpen', isOpen)}
              >
                <SearchForm
                  clientToken={this.props.clientToken}
                  handleDateInputChange={this.handleDateInputChange}
                  handleTextInputChange={this.handleTextInputChange}
                  handleStateInputChange={this.handleStateInputChange}
                  handleKeyUp={this.handleKeyUp}
                  availableDates={this.available_dates}
                  currentDate={this.state.currentDate}
                  usStates={this.props.us_states}
                  changeState={this.changeState}
                  onChange={this.handleBooleanInputChange}
                  groupSelections={this.state.group_selections}
                  notesCategories={this.state.notesCategories}
                  us_states={this.props.us_states}
                  currentState={this.state.current_state}
                />

                <SearchCheckboxes
                  clientToken={this.props.clientToken}
                  handleDateInputChange={this.handleDateInputChange}
                  handleToggleCurrent={this.handleToggleCurrent}
                  handleTogglePrevious={this.handleTogglePrevious}
                  availableDates={this.available_dates}
                  currentDate={this.state.current_date}
                  previousDate={this.state.previous_date}
                  us_states={this.props.us_states}
                  notesCategories={this.state.notesCategories}
                  onChange={this.handleBooleanInputChange}
                  showComparison={this.state != null && this.state.previous_date !== null}
                  newChecked={this.state != null && this.state.group_selections['new']}
                  isNewChecked={this.state != null && this.state.group_selections['is_new']}
                  handleTextInputChange={this.handleTextInputChange}
                  handleStateInputChange={this.handleStateInputChange}
                  handleCategoryInputChange={this.handleCategoryInputChange}
                  handleDatePickerChange={this.handleDatePickerChange}
                  handleKeyUp={this.handleKeyUp}
                  changeState={this.changeState}
                  currentState={this.state.current_state}
                  groupSelections={this.state.group_selections}
                  database={this.props.database}
                />
              </CollapseCard>

              <SearchNotes
                clientToken={this.props.clientToken}
                handleDateInputChange={this.handleDateInputChange}
                handleToggleCurrent={this.handleToggleCurrent}
                handleTogglePrevious={this.handleTogglePrevious}
                availableDates={this.available_dates}
                currentDate={this.state.current_date}
                previousDate={this.state.previous_date}
                us_states={this.props.us_states}
                notesCategories={this.state.notesCategories}
                onChange={this.handleBooleanInputChange}
                showComparison={this.state != null && this.state.previous_date !== null}
                newChecked={this.state != null && this.state.group_selections['new']}
                isNewChecked={this.state != null && this.state.group_selections['is_new']}
                handleTextInputChange={this.handleTextInputChange}
                handleStateInputChange={this.handleStateInputChange}
                handleCategoryInputChange={this.handleCategoryInputChange}
                handleDatePickerChange={this.handleDatePickerChange}
                handleKeyUp={this.handleKeyUp}
                changeState={this.changeState}
                currentState={this.state.current_state}
                groupSelections={this.state.group_selections}
              />

              {useSECData && <SearchStatistics
                clientToken={this.props.clientToken}
                currentDate={this.state.current_date}
                previousDate={this.state.previous_date}
                us_states={this.props.us_states}
                notesCategories={this.state.notesCategories}
                handleBooleanInputChange={this.handleBooleanInputChange}
                showComparison={this.state != null && this.state.previous_date !== null}
                handleTextInputChange={this.handleTextInputChange}
                handleKeyUp={this.handleKeyUp}
                group_selections={this.state.group_selections}
                search_option_groups={this.search_option_groups}
              />}

              {/* </Col>
            </Row> */}
            </Container>
          </Container>

          <SearchFooter
            handleReset={this.handleReset}
            handleSubmit={this.handleSubmit}
            showAll={this.state.showAll}
            setShowAll={() => this.setState({ showAll: !this.state.showAll })}
            pageSizeOptions={this.pageSizeOptions}
          />
        </div>
      );
    }
  }
}

export default AdvancedSearch;
